
    import { mdiRestart } from '@mdi/js';
    import { VueConstructor } from 'vue';
    import { Component, Prop, Vue } from 'vue-property-decorator';
    import {
        VBtn,
        VFlex,
        VForm,
        VIcon,
        VLayout,
        VList,
        VListItem,
        VMenu,
    } from 'vuetify/lib';
    import { TuningGroup } from '@/tunings/types';

    import BooleanInput from './Form/BooleanInput.vue';
    import MultiInput from './Form/MultiInput.vue';
    import NumericInput from './Form/NumericInput.vue';
    import StringInput from './Form/StringInput.vue';

    @Component({
        components: {
            VBtn,
            VFlex,
            VForm,
            VIcon,
            VLayout,
            VList,
            VListItem,
            VMenu,
            BooleanInput,
            MultiInput,
            NumericInput,
            StringInput,
        },
    })
    export default class Menu extends Vue {
        @Prop({ required: true })
        readonly groups!: TuningGroup[];

        iconMdiRestart = mdiRestart;

        getType(groupIndex: number, propIndex: number): VueConstructor<Vue> {
            switch (typeof this.groups[groupIndex].properties[propIndex].default) {
                case 'boolean':
                    return BooleanInput;
                case 'number':
                    return NumericInput;
                case 'object':
                    return MultiInput;
                default:
                    return StringInput;
            }
        }

        get isFactionMultiForm(): boolean {
            return this.groups.length === 2;
        }

        reset(all: boolean) {
            this.$emit('reset', all);
        }
    }
